<template>
  <!-- Title of the box -->
  <v-layout>
    <v-row>
      <v-col class="py-0 pl-0 ma-1">
        <v-card ref="form" width="100%">
          <div>            
            <v-chip class="ma-2" color="teal" text-color="white">
              <b><span v-html="title"></span></b>              
            </v-chip>
            <HelpIcon :help="htext1"/>
          </div>
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.nmkh"
            label="ឈ្មោះជាអក្សរខ្មែរ"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.nmen"
            label="ឈ្មោះជាអក្សរឡាតាំង"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.nato"
            label="សញ្ជាតិ"
          />
          <v-text-field
            class="ttext my-0 px-1"
            placeholder="dd-mm-yyyy"
            :rules="[rules.dob]"
            outline
            v-model="data.dobt"
            label="ថ្ងៃ ខែ ឆ្នាំកំណើត"
          />
          <v-select
            class="px-1"
            v-model="data.gend"
            :items="gender"
            item-text="text"
            item-value="value"
            outline
            label="ភេទ"
            hide-details
            @keypress.native="onSelect1($event)"
          >
          </v-select>
          <v-select
            class="px-1"
            v-model="data.degr"
            :items="degree"
            item-text="text"
            item-value="value"
            outline
            label="កម្រិតវប្បធម៌"
            hide-details
            @keypress.native="onSelect3($event)"
          >
          </v-select>
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.tose"
            type="number"
            label="សរុបចំនួនឆ្នាំបម្រើការងារអប់រំ"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.todi"
            type="number"
            label="ចំនួនឆ្នាំបម្រើការងារជានាយក"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.tote"
            type="number"
            label="ចំនួនម៉ោងបង្រៀនក្នុង១សប្ដាហ៍"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.teld"
            label="លេខទូរស័ព្ទរបស់នាយក/នាយិកា"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.emdi"
            label="សារអេឡិចត្រូនិច (E-mail)"
          />
          <v-chip class="ma-2" color="teal" text-color="white">
            <b>១.(គ) លេខកូតសាលារៀនឆ្នាំមុន​(បើមាន)</b>            
          </v-chip>
          <HelpIcon :help="htext2"/>
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="ldata.lidk"
            label="លេខកូតមត្តេយ្យសិក្សាឆ្នាំមុន"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="ldata.lidp"
            label="លេខកូតបឋមសិក្សាឆ្នាំមុន"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="ldata.lidl"
            label="លេខកូតអនុវិទ្យាល័យឆ្នាំមុន"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="ldata.lidu"
            label="លេខកូតវិទ្យាល័យឆ្នាំមុន"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import { maleFemale, degree } from "@/utils/ascf/commonConfig.js";

export default {
  props: ["data", "ldata", "title", "htext1", "htext2"],
  data() {
    return {
      gender: maleFemale,
      degree: degree,
      rules: {
        // :rules="[rules.required, rules.email]"
        required: (value) => !!value || "Required.",
        dob: (value) => {
          const pattern = /^(0[1-9]|[12][0-9]|3[01])[-/.](0[1-9]|1[012])[-/.](19|20)\d\d$/;
          if (pattern.test(value)) {
            return true;
          } else {
            return "សូមវាយទំរង់ dd-mm-yyyy";
          }
        },
      }
    };
  },
  methods: {
    onSelect1: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data.gen = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect3: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 57) {
        this.data.educ = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
</style>